import { COLORS } from 'helpers/globals'

export default {
  html: {
    boxSizing: 'border-box',
    fontSize: '62.5%',
    height: '100%',
    '@media screen and (max-width: 350px)': {
      fontSize: '50%'
    }
  },
  body: {
    color: COLORS.secondary,
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: '1.6em',
    fontWeight: 300,
    letterSpacing: '.01em',
    lineHeight: '1.6',
    height: '100%'
  },
  'div#app > div': {
    height: '100%'
  },
  '*, *:after, *:before': {
    boxSizing: 'inherit'
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/base.js